export const AD_PICTURE_MODEL = 'ad';

export interface AdPicture {
  id?: number;
  name?: string;
  zone: number;
  type: string;
  display: string;
  object?: string;
  refresh?: number;
  model_type?: typeof AD_PICTURE_MODEL;
  channelable_id?: number;
  channelable_order?: number;
}
